<template>
  <div>
    <v-container
      :style="{
        padding: $vuetify.breakpoint.mobile ? undefined : '0px 110px 0px 110px',
      }"
    >
      <br />
      <v-row>
        <v-col cols="12" class="pa-0">
          <v-card flat color="transparent">
            <v-card-title style="color: #395da5">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    class="mr-6"
                    :to="{
                      name: 'survey',
                    }"
                    @click="
                      $router.push({
                        name: 'survey',
                      })
                    "
                    >keyboard_double_arrow_left</v-icon
                  >
                </template>
                <span>กลับหน้าแรก</span>
              </v-tooltip>
              {{ $route.params.surveyName }}
            </v-card-title>
          </v-card></v-col
        ></v-row
      >
      <br />
      <v-data-table
        :headers="headers"
        :items="storeRole"
        sort-by="name"
        class="elevation-1"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title>ผู้ใช้งาน</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <!-- <AddRole /> -->
            <v-btn
              :disabled="!AccPermission.createInvite"
              color="#033666"
              class="white--text rounded-lg"
              @click="getInviteURL"
              dark
              >invite</v-btn
            >
          </v-toolbar>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-row no-gutters v-if="item.roleID !== 'Owner'">
            <v-col cols="5"
              ><EditRole v-if="AccPermission.update" :user="item"
            /></v-col>
            <v-col cols="5"
              ><v-btn
                v-show="userlogin.userID !== item.userID"
                v-if="AccPermission.delete"
                color="#DE4F3B"
                icon
                @click="DelRole(item)"
                ><v-icon>delete</v-icon></v-btn
              ></v-col
            >
          </v-row>
        </template>
      </v-data-table>
    </v-container>
    <v-dialog v-model="invite" @click:outside="copied = false" width="500">
      <v-card>
        <v-card-title> Invite URL </v-card-title>
        <v-card-text> คัดลอก URL เพื่อ invite มาใช้ survey นี้ </v-card-text>
        <v-card-text class="d-flex align-center">
          <v-text-field
            hide-details
            outlined
            ref="link"
            :label="copied ? 'URL copied' : 'Click to copy URL'"
            class="pa-4"
            readonly
            :value="url"
            @click="copy"
          ></v-text-field>
          <v-btn color="#1184bd" icon @click="copy"
            ><v-icon class="mx-3">content_copy</v-icon></v-btn
          >
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="(invite = false), (copied = false)"
          >
            ปิดหน้าต่าง
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar" :timeout="2000">
      คัดลอกเรียบร้อย
      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">
          ปิด
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import Swal from "sweetalert2";
// import AddRole from "./AddRole.vue";
import EditRole from "./EditRole.vue";
export default {
  components: { EditRole },
  created() {
    this.$store.state.rolelist = [];
    this.$store.dispatch("CheckPermission").then((resp_role) => {
      if (resp_role.data.permission) {
        if (Object.keys(resp_role.data.permission).length !== 0) {
          this.$store.commit("UpdateUserPermission", resp_role.data);
          if (resp_role.data.permission.account.view) {
            this.$store.dispatch("getPermission");
            this.$store.dispatch("getRole");
          } else {
            Swal.fire({
              icon: "error",
              text: "คุณไม่มีสิทธิ์เข้าถึงหน้านี้",
              title: "",
            }).then(() => {
              this.$router.push({
                name: "question",
              });
            });
          }
        } else {
          Swal.fire({
            icon: "error",
            text: "คุณไม่มีสิทธิ์เข้าถึงหน้านี้",
            title: "",
          }).then(() => {
            this.$store.commit("UpdateUserPermission", resp_role.data);
            this.$router.push({
              name: "question",
            });
          });
        }
      }
    });
  },
  data() {
    return {
      invite: false,
      url: "",
      copied: false,
      snackbar: false,
      headers: [
        { text: "ชื่อผู้ใช้งาน", value: "displayName", width: "40%" },
        { text: "Role", value: "role", width: "40%" },
        { text: "", value: "actions", width: "20%" },
      ],
    };
  },
  computed: {
    storeRole() {
      return this.$store.state.rolelist;
    },
    AccPermission() {
      return this.$store.state.user_permission.account;
    },
    userlogin() {
      if (this.$cookies.get(process.env.VUE_APP_CM_AUTH_COOKIE + "_token")) {
        return this.$jwtDecode(
          this.$cookies.get(process.env.VUE_APP_CM_AUTH_COOKIE + "_token")
        );
      }
      return "";
    },
  },
  methods: {
    getInviteURL() {
      // console.log(this.$route.params);
      this.$store.dispatch("CheckPermission").then((resp_role) => {
        if (resp_role.data.permission) {
          if (Object.keys(resp_role.data.permission).length !== 0) {
            this.$store.commit("UpdateUserPermission", resp_role.data);
            if (resp_role.data.permission.account.view) {
              this.$store
                .dispatch("getInviteURL", {
                  serviceName: "CMSurvey",
                  productID: this.$route.params.surveyID,
                  productName: this.$route.params.surveyName,
                })
                .then((resp) => {
                  this.url = resp.data.urlInvite;
                  this.invite = true;
                });
            } else {
              Swal.fire({
                icon: "error",
                text: "สิทธิ์การ invite ของคุณถูกปฏิเสธ",
                title: "",
              }).then(() => {
                this.$router.push({
                  name: "question",
                });
              });
            }
          } else {
            Swal.fire({
              icon: "error",
              text: "สิทธิ์การ invite ของคุณถูกปฏิเสธ",
              title: "",
            }).then(() => {
              this.$store.commit("UpdateUserPermission", resp_role.data);
              this.$router.push({
                name: "question",
              });
            });
          }
        }
      });
    },
    DelRole(item) {
      let text = item.displayName;
      Swal.fire({
        text: `ยืนยันการลบ "${text}"`,
        icon: "warning",
        focusConfirm: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "ตกลง",
        cancelButtonText: "ยกเลิก",
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("DeleteRole", {
              surveyID: this.$route.params.surveyID,
              userID: item.userID,
            })
            .then(() => {
              Swal.fire({
                icon: "success",
                text: `ลบ "${text}" เรียบร้อยแล้ว`,
                title: "",
                showConfirmButton: false,
                timer: 1500,
              }).then(() => {
                this.$store.dispatch("getRole");
              });
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                text:
                  error.data.message === "role is duplicate"
                    ? "มีการใช้ชื่อนี้ไปแล้ว"
                    : error.data.message === "Permission Denied"
                    ? "คุณไม่มีสิทธิ์เข้าถึงการลบ"
                    : "ไม่สามารถลบได้",
                title: "",
              }).then(() => {
                this.$store.dispatch("getRole");
                this.$store.commit("ToggleLoading");
                if (error.data.message === "Permission Denied") {
                  this.$store
                    .dispatch(
                      "getQuestionPermission",
                      this.$route.params.surveyID
                    )
                    .then(() => {
                      this.$router.push({
                        name: "question",
                      });
                    });
                }
              });
            });
        }
      });
    },
    copy() {
      const markup = this.$refs.link;
      markup.focus();
      document.execCommand("selectAll", false, null);
      this.copied = document.execCommand("copy");
      this.snackbar = true;
    },
  },
};
</script>

<style lang="scss" scoped></style>
